export class SelectBoxItemModel {
  name: string;
  code: string;
}
